import { render, staticRenderFns } from "./projects-media-create.vue?vue&type=template&id=afc7b416&scoped=true&"
import script from "./projects-media-create.vue?vue&type=script&lang=js&"
export * from "./projects-media-create.vue?vue&type=script&lang=js&"
import style0 from "./projects-media-create.vue?vue&type=style&index=0&id=afc7b416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc7b416",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VOverlay,VProgressCircular})
